module.exports = __webpack_public_path__ + "images/help/header-background-abc78e50dd425b00ce09778e9357d907.png";